import { IModelInfo } from "../ModelInfos/IModelInfo";

export enum ParserId {
    Json = "json",
    Csv = "csv",
    Csharp = "csharp",
    Typescript = "typescript",
    Sql = "sql"
}

export interface IParser {
    id: ParserId;
    name: string;
    parseChunk: (data: string) => IModelInfo[]
}